// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__piNs9","footer":"ModalFilter_footer__5c6zp"};